import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import './table.scss';

const Table = (props) => {
    const { children, mix } = props;

    return <div className={cx('table', mix)}>{children}</div>;
};

Table.propTypes = {
    children: PropTypes.node,
    mix: PropTypes.string,
};

export default Table;
